import React from "react";
import "../Css/Python.css";

import { PyFooter } from "./PyFooter";
import { useState, useEffect } from "react";
import { DotLoader } from "react-spinners";
import { Navbar } from "../Components/Nav";

const override = {
  display: "block",
  margin: "auto",
  borderColor: "red",
};

export const PyFirstStep = () => {
  const [loading, setLoading] = useState(false);
  let [color] = useState("#FF8C00");

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);
  return (
    <>
      <div className="App">
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignContent: "center",
              paddingTop: "210px",
            }}
          >
            <DotLoader
              color={color}
              loading={loading}
              cssOverride={override}
              size={100}
            />
          </div>
        ) : (
          <>
            <div class="container-fluid background_py">
              <div className="row">
                <Navbar />
                <div className="col-md-3"></div>
                <div className="col-md-6">
                  <div>
                    <img
                      className="logo"
                      src={process.env.PUBLIC_URL + "assets/images/pyLogo.png"}
                      width="65%"
                      alt="pylogo.png"
                      height="auto"
                    />
                  </div>
                </div>
                <div className="col-md-3"></div>
              </div>
            </div>

            <div
              class="container-fluid"
              style={{
                backgroundColor: "black",
                paddingTop: "60px",
              }}
            >
              <div className="row mt-2">
                <h1 className="py_h1">Python – First Step</h1>

                <div>
                  <p>
                    We will learn here how to write and run python programs.
                    Before you start, you should have Python installed on your
                    computer.
                  </p>
                </div>
              </div>

              <hr style={{ color: "white" }} />
              <div className=" row mt-4">
                <h1 className="py_h1">Install Python and IDLE</h1>
                <div>
                  <p>
                    Python comes pre-installed with Ubuntu and Mac OS, but it
                    does not come pre-installed with the Windows operating
                    system. You need to download and install manually from the
                    official website of python
                    <span
                      style={{
                        color: "orange",
                        paddingLeft: "5px",
                        paddingRight: "5px",
                      }}
                    >
                      <a href="https://www.python.org/downloads/">
                        https://www.python.org/downloads/.
                      </a>
                    </span>
                    and install it in very simple steps.<br></br>
                    IDLE: Python IDLE (Integrated development and learning
                    environment ) is an integrated environment for python
                    programming. IDLE is a simple IDE and suitable for beginners
                    and an educational environment. For window users, it is a
                    part of the python software, you need not install it
                    separately. For Linux user, run below command in Terminal.
                  </p>
                </div>
              </div>
              <div className="bg-primary" style={{ fontWeight: "bolder" }}>
                <p className="text-light">
                  sudo apt-get install python3 idle3.
                </p>
              </div>

              <hr style={{ color: "white" }} />
              <div className=" row mt-4">
                <h1 className="py_h1">Python Version Check</h1>
                <p>
                  {" "}
                  Run below command from terminal or cmd to check python
                  installed on your PC and version of python.
                </p>
              </div>

              <div className="bg-primary" style={{ fontWeight: "bolder" }}>
                <p className="text-light">python --version </p>
              </div>
              <hr style={{ color: "white" }} />
              <div className=" row mt-4">
                <h1 className="py_h1">Working in Python.</h1>
                <p>
                  {" "}
                  Now python is installed in your PC, and you are ready to work
                  with python environment. You can work in Python in two
                  different ways. Interactive mode and Script mode <br />
                  <br />
                  <span
                    style={{
                      color: "orange",
                      paddingLeft: "5px",
                      paddingRight: "5px",
                    }}
                  >
                    Interactive mode –
                  </span>{" "}
                  you can run python command and you can use python as a
                  calculator. You can execute one command at a time only, after
                  every execution it produces the result. <br />
                  <br />
                  <span
                    style={{
                      color: "orange",
                      paddingLeft: "5px",
                      paddingRight: "5px",
                    }}
                  >
                    Script mode –
                  </span>{" "}
                  Here you can write multiple lines of code as a file with a .py
                  extension and execute the file as a python program. We will
                  discuss the python scripting mode in the next chapter.
                </p>
              </div>

              <hr style={{ color: "white" }} />
              <div className=" row mt-4">
                <h1 className="py_h1">Python as a Calculator</h1>
                <p>
                  {" "}
                  We can use Python as a calculator. to use python as a
                  calculator we will use the interactive mode of python. For
                  Interactive mode, you need to open Python IDLE from start menu
                  in Window: Start {`->`} Program {`->`} Search IDLE <br /> Mac
                  or Ubuntu: Type IDLE3 in your terminal window. The above
                  command will open the Python shell, you can write any complex
                  calculation.
                </p>
                <div
                  // className="bg-info"
                  style={{
                    textAlign: "center",
                    backgroundColor: "#5d7b89",
                    fontFamily: "Fira Mono",

                    fontWeight: "bolder",
                  }}
                >
                  <h3>Example </h3>

                  <li>Python 3.4.3 (default, Oct 2 2022, 22:20:49)</li>
                  <li>[GCC 4.8.4] on linux</li>
                  <li>
                    {" "}
                    Type "help", "copyright", "credits" or "license" for more
                    information.
                  </li>
                </div>
                <div className="bg-primary">
                  <p>
                    Note-: You can see the symbol {`>>>`}, where you can write
                    calculation, python will print result.
                  </p>
                </div>
              </div>

              <hr style={{ color: "white" }} />
              <div className=" row mt-4">
                <h1 className="py_h1">Some More Examples</h1>
                <div
                  // className="bg-info"
                  style={{
                    textAlign: "center",
                    fontWeight: "bolder",
                    backgroundColor: "#5d7b89",
                    fontFamily: "Fira Mono",
                  }}
                >
                  <h3>Example </h3>
                  <li> {`>>>`} 12+12</li>
                  <li style={{ color: "orange" }}> 24</li>
                  <li> {`>>>`} 12+12*12</li>
                  <li style={{ color: "orange" }}>156</li>
                  <li> {`>>>`} (12+12)*12</li>
                  <li style={{ color: "orange" }}>288</li>
                </div>
                <div className="bg-primary">
                  <p>
                    Note-: You can see the symbol {`>>>`}, where you can write
                    calculation, python will print result.
                  </p>
                </div>
              </div>
              <hr style={{ color: "white" }} />
              <div className=" row mt-4">
                <h1 className="py_h1">Arithmetic Operators</h1>
                <div
                  // className="bg-info"
                  style={{
                    textAlign: "center",
                    fontWeight: "bolder",
                    backgroundColor: "#5d7b89",
                    fontFamily: "Fira Mono",
                  }}
                >
                  <div class="row">
                    <h3>Example </h3>
                    <div className="col-md-4"></div>
                    <div className="col-md-4">
                      <ul>
                        <li> {`>>>`} 10+3 # Print Addition</li>
                        <li>
                          <p style={{ color: "orange" }}> 13 </p>
                        </li>
                        <li> {`>>>`} 10-3 # Print Subtraction</li>
                        <li>
                          {" "}
                          <p style={{ color: "orange" }}> 7 </p>
                        </li>
                        <li> {`>>>`} 10*3 # Print Multiplication</li>
                        <li>
                          {" "}
                          <p style={{ color: "orange" }}> 30</p>
                        </li>
                        <li> {`>>>`} 10/3 # Floating Divison</li>
                        <li>
                          {" "}
                          <p style={{ color: "orange" }}> 3.3333333333</p>
                        </li>
                        <li> {`>>>`} 10//3 # Integer Divison</li>
                        <li>
                          {" "}
                          <p style={{ color: "orange" }}> 3 </p>
                        </li>
                        <li> {`>>>`} 10%3 # Modulus, #Return Remainder</li>
                        <li>
                          {" "}
                          <p style={{ color: "orange" }}> 1 </p>
                        </li>
                        <li> {`>>>`} 10**3 # Exponent, Cube of 10</li>
                        <li>
                          {" "}
                          <p style={{ color: "orange" }}> 100</p>
                        </li>
                      </ul>
                    </div>
                    <div className="col-md-4"></div>
                  </div>
                </div>
                <div className="bg-primary">
                  <p>
                    Note-: You can see the symbol ({`>>>`}), where you can write
                    calculation, python will print result.
                  </p>
                </div>
              </div>
            </div>
            <PyFooter />
          </>
        )}
      </div>
    </>
  );
};
